
import React, { useState } from "react";
import { Calendar, Shirt, ShoppingBag, PartyPopper } from "lucide-react";
import FeatureCard from "./FeatureCard";

const FeaturesGrid = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const features = [
    {
      title: "Book an Event",
      description: "Schedule MAD-Ts for your next party or special occasion",
      icon: <Calendar className="h-10 w-10" />,
      color: "from-madts-purple to-madts-pink",
      delay: 0.1,
      link: "/book"
    },
    {
      title: "Custom Printing",
      description: "Upload your designs for t-shirts, totes, and more",
      icon: <Shirt className="h-10 w-10" />,
      color: "from-madts-pink to-madts-blue",
      delay: 0.2,
      link: "/custom"
    },
    {
      title: "Shop Products",
      description: "Browse our catalog of customizable merch",
      icon: <ShoppingBag className="h-10 w-10" />,
      color: "from-madts-blue to-purple-500",
      delay: 0.3,
      link: "/shop"
    },
    {
      title: "Business Collabs",
      description: "Partner with MAD-Ts for your local business event",
      icon: <PartyPopper className="h-10 w-10" />,
      color: "from-purple-500 to-madts-purple",
      delay: 0.4,
      link: "/business"
    }
  ];

  return (
    <div className="px-6 pb-20">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {features.map((feature, index) => (
          <FeatureCard
            key={index}
            feature={feature}
            isHovered={hoveredCard === index}
            onHover={(isHovered) => setHoveredCard(isHovered ? index : null)}
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturesGrid;
